import { loader } from 'graphql.macro'

export default function reportsTicketHeatmapQuery ({ dataLoaders, queryKey }) {
  const [,
    startDate,
    endDate,
    years,
    resourceTypeIds,
    ticketTypeIds,
    driverIds,
    status
  ] = queryKey

  const reportsTicketHeatmapSchema = loader('./reportsTicketHeatmap.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(reportsTicketHeatmapSchema, { startDate, endDate, years, resourceTypeIds, ticketTypeIds, driverIds, status })
}
